import { ChakraButton } from "@airhelp/react-ui-components";
import { trackUAEvent, trackCustomEvent } from "utils/tracking";
import type { NavButtonProps } from "./NavButton.d";

export const NavButton = ({ href, title, gaEvent, uaEvent, dataTestId }: NavButtonProps) => {
  const handletrackEvents = () => {
    trackUAEvent(uaEvent);
    trackCustomEvent(gaEvent);
  };

  return (
    <ChakraButton
      variant="secondary"
      as="a"
      href={href}
      title={title}
      ml={{ lg: 1, xl: 8 }}
      px={{ lg: 3, xl: 6 }}
      width={{ base: "full", lg: "initial" }}
      order={{ base: "2", md: "1" }}
      onClick={handletrackEvents}
      data-testid={dataTestId}
      lineHeight="short"
    >
      {title}
    </ChakraButton>
  );
};
